import template from './user_signatures.html';

class UserSignaturesViewModel
{
	constructor (page)
	{
		this.page = page;
		this.user_signatures = ko.observableArray();
		this.search_string = ko.observable('');
		this.place_holder = ko.observable(tr('Search users...'));

		// Pagination
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);

		this.search_string.subscribe((val) => {
    		clearTimeout(this._search_timeout);
    		this._search_timeout = setTimeout(() => {
    		    this.current_page_number(1);
    		    this.page.updateData();
    		}, 300); // wait 300ms after last keystroke to send request instead of sending requests after each keystroke 
		});

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.current_page_number(1);
			this.page.updateData();
		});
	};

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	};

	async upload_signature(user_id)
	{
		await Grape.dialog.open('UserSignatureUpload', { user_id: user_id });
		this.page.updateData();
	}
	
	user_signature_help()
	{
		Grape.dialog.open('UserSignatureHelp', { employee_id: this.page.bindings.id });
	};
};

class UserSignatures
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new UserSignaturesViewModel(this);
	}

	init()
	{
		document.title = tr('User Signatures');
		window.current_page_title(tr('User Signatures'));
	}

	async updateData()
	{
		let limit = this.viewModel.current_page_size();
		let offset = (this.viewModel.current_page_number() - 1) * limit;

		let data = {
			table: 'v_payment_users',
			schema: 'grape_payment_approval',
			limit: limit,
			offset: offset,
			filter_join: 'OR',
			filter: []
		}

		if (this.viewModel.search_string() != '' && this.viewModel.search_string())
		{
			data.filter.push({ 
				value: `%${this.viewModel.search_string()}%`,
				operand: 'ILIKE',
				field: 'fullnames'
			},{
				value: `%${this.viewModel.search_string()}%`,
				operand: 'ILIKE',
				field: 'username'
			});
		}

		let res = await Grape.fetches.getJSON('/api/record', data);

		if (res.status != 'ERROR')
		{
			this.viewModel.user_signatures(res.records);

			let total = res.total || res.records.length;
			this.viewModel.page_count(Math.ceil(total / limit));
			this.viewModel.pagination_summary(
				`Showing ${offset + 1} to ${Math.min(offset + limit, total)} of ${total} entries`
			);
		}
		else
			Grape.alerts.apiError(res);
	};
};

export default {
	route: '[/]payment_approval/user_signatures',
	page_class: UserSignatures,
	template: template,
	template_filename: 'translation/user_signatures'
};

